import { BaseAtlas } from './BaseAtlas';

/**
 * Auto-generated class for atlas "backgroundsSpritesheets/tablet/31_mountains/31_mountains"
 * Contains 1 texture(s)
 */
export class Tablet31MountainsAtlas extends BaseAtlas {
    /**
     * Atlas path
     */
    protected static readonly ATLAS_PATH = 'backgroundsSpritesheets/tablet/31_mountains/31_mountains';

    /**
     * List of all available textures in atlas
     */
    protected static readonly TEXTURES = [
        '31_mountains.jpg'
    ] as const;
}
